import { Autocomplete, TextField } from '@mui/material';
import type { ErpMetadata, NetSuiteProduct } from '@weft/types';
import { isEmptyArray, isEmptyString, isNotNullOrUndefined } from '@weft/utils';
import { useNetSuiteProducts } from 'apps/app/src/hooks/requests/use-net-suite';
import React, { useMemo } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type NetSuiteProductsDropdownProps<FormType extends FieldValues> = {
  fieldPath: FieldPath<FormType>;
  control: Control<FormType>;
  showDropdown: boolean;
};

export function NetSuiteProductsDropdown<FormType extends FieldValues>({ fieldPath, control, showDropdown }: NetSuiteProductsDropdownProps<FormType>) {
  const { data: { products } = {} } = useNetSuiteProducts({ enabled: showDropdown });

  const productsErpData = useMemo(() => netSuiteProductsToErpData(products), [products]);

  return (
    <Controller
      control={control}
      name={fieldPath}
      render={({ field }) => (
        <Autocomplete
          disabled={!showDropdown}
          options={productsErpData}
          getOptionLabel={({ erpName }) => isNotNullOrUndefined(erpName) ? erpName : ''}
          getOptionDisabled={(option) => option.erpId === field.value?.erpId}
          onChange={(_, value) => {
            console.info('value', value);
            field.onChange(value);
          }}
          value={field.value}
          renderInput={(params) => (
            <TextField
              { ...field}
              { ...params}
              label="Products"
              placeholder="Select NetSuite Product"
              focused
              InputLabelProps={{
                shrink: true,
              }}
              onChange={e => {
                if (isEmptyString(e.target.value)) {
                  field.onChange(null);
                }
              }}
            />
          )}
        />
      )}
    />
  );
}

function netSuiteProductsToErpData(products: NetSuiteProduct[] | undefined) {
  return isEmptyArray(products)
    ? []
    : products.map<ErpMetadata>(({ id, name }) => ({
      erpId: id,
      erpName: name,
    }));
}